// extracted by mini-css-extract-plugin
export var form = "styles-module__form___JXfGz";
export var lngLat = "styles-module__lngLat___zxYwt";
export var textFieldContainer = "styles-module__textFieldContainer___inuNq";
export var formToggle = "styles-module__formToggle___Eb0Tu";
export var buttonAndLinks = "styles-module__buttonAndLinks___K0kmO";
export var adminButton = "styles-module__adminButton___SJ5ND";
export var errorMessage = "styles-module__errorMessage___g6RNk";